(ns app.front.ui.select-card
  (:require [core.front.carbon :as cc]))

(defn card [{:keys [on-select selected? id]} & children]
  [:label.bg-ui-blue-10.rounded-md.border.border-solid.flex.flex-row.cursor-pointer.my-2
   {:class (if selected? "border-ui-violet-100" "border-transparent")}
   [:div.flex.items-center.justify-center.p-6
    (cc/checkbox {:id         (str "select-card-checkbox" id)
                  :label-text ""
                  :hide-label true
                  :checked    (or selected? false)
                  :on-change  on-select})]
   (into [:div.flex-1.p-6.pl-0]
         children)])
